import { ChangeEvent } from 'react';
import { Box, InputAdornment, Stack, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { LayoutSwitcher } from './LayoutSwitcher.tsx';
import { useDashboardStore, GridLayout } from '../../store/flashbackStore/dashboardStore.ts';
import React from 'react';

export function Toolbar(): React.ReactElement {
  const { filters, layout, setSearch, setLayout } = useDashboardStore();

  const handleSearch = (e: ChangeEvent<HTMLInputElement>): void => setSearch(e.target.value);
  const handleLayout = (next: GridLayout): void => setLayout(next);

  return (
    <Stack
      direction="row"
      spacing={1}
      alignItems="center"
      flexWrap="wrap"
      useFlexGap
      sx={{ gap: 1, mb: 2, pt: '10px', px: '8px' }}
    >
      <TextField
        type="search"
        size="small"
        value={filters.search}
        onChange={handleSearch}
        placeholder="Search cameras…"
        autoComplete="off"
        inputProps={{ 'aria-label': 'Search cameras' }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon sx={{ color: '#9E9E9E', fontSize: 20 }} />
            </InputAdornment>
          ),
        }}
        sx={{
          flex: '1 1 260px',
          minWidth: 260,
          maxWidth: 560,
          '& .MuiOutlinedInput-root': {
            borderRadius: '24px',
            backgroundColor: '#FAFAFA',
            fontFamily: 'Roboto, sans-serif',
            fontSize: '14px',
            '& fieldset': { borderColor: '#E0E0E0' },
            '&:hover fieldset': { borderColor: '#E0E0E0' },
            '&.Mui-focused fieldset': {
              borderColor: '#2932E5',
            },
          },
        }}
      />

      <Box sx={{ ml: 'auto' }}>
        <LayoutSwitcher value={layout} onChange={handleLayout} />
      </Box>
    </Stack>
  );
}
